<template>
  <div id="footer" class="container-fluid px-0 mt-auto">
    <footer class="footer text-center py-3">
      <div class="copyright pt-3 pb-3">
        <p class="footer-text">Theme Park Buddy  <strong>{{ currentDate() }}</strong></p>
      </div>
      <div class="pb-3 fw-bold">
        <router-link to="/">
          <h3 class="footer-text">Back Home</h3>
        </router-link>
      </div>
      <div class="px-3 px-sm-5">
        <p class="lead">This website is an independent informational project and is not affiliated with, endorsed by, sponsored by, or in any way officially connected to The Walt Disney Company, NBCUniversal, or any of their subsidiaries or affiliates. All official park names, attraction names, trademarks, and registered trademarks belong to their respective owners. Wait time data is provided for informational purposes only via Queue-Times.com.</p>
        <p><a href="https://queue-times.com/" target="_blank">Powered by Queue-Times.com</a></p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  methods: {
    currentDate() {
      const current = new Date();
      const date = `${current.getFullYear()}`;
      return date;
    }
  }
}
</script>